import React from "react";

const BG =
  "https://static.prod-images.emergentagent.com/jobs/140329da-214d-4361-8f65-2aa02dd6ca18/images/b638631380ada1b2537ffa76fd441e106b00b55772897935cd3490904dfa1d54.png";

export default function About() {
  return (
    <section
      id="about"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="text-[11px] uppercase tracking-[0.4em] text-[#D4AF37] mb-5">
              About Pegasus Infra
            </div>
            <h2 className="font-serif text-4xl md:text-5xl text-white leading-tight mb-8">
              Structure to complexity.
              <br />
              <span className="italic text-[#D4AF37]">One accountable system.</span>
            </h2>
            <div className="pg-gold-line mb-8" />
            <div className="relative aspect-[4/5] border border-white/10 overflow-hidden">
              <img
                src={BG}
                alt="Architectural detail"
                className="w-full h-full object-cover opacity-90"
              />
            </div>
          </div>

          <div className="lg:col-span-7 space-y-10 text-[#A3A3A3] leading-relaxed">
            <p className="text-lg md:text-xl text-white font-serif leading-relaxed">
              Pegasus Infra is a design-led construction firm delivering
              end-to-end civil solutions. We integrate architecture, engineering,
              construction and interiors into a single aligned system — one
              partner, one accountability, one result.
            </p>
            <p>
              Backed by over 24 years of industry experience, our team combines
              deep technical expertise with sharp market insight to ensure every
              project is structurally sound and economically optimised. We place
              strong emphasis on precision, accountability and time-bound
              execution to deliver long-term value.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
              {[
                {
                  t: "Our Mission",
                  d: "To bring structure to complexity — aligning design, execution and responsibility under one accountable system.",
                },
                {
                  t: "Our Vision",
                  d: "For clients who value certainty, discipline and long-term thinking, we offer a way to build without chaos and without compromise.",
                },
                {
                  t: "Our Approach",
                  d: "Integrated Design-Build. A single seamless delivery model, from feasibility through final walkthrough.",
                },
                {
                  t: "Our Promise",
                  d: "Consistent quality, speed and cost efficiency — delivered without surprises.",
                },
              ].map((b) => (
                <div
                  key={b.t}
                  className="bg-[#0A0A0A] p-8 pg-hover-lift hover:bg-[#141414]"
                  data-testid={`about-card-${b.t.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <div className="text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-3">
                    {b.t}
                  </div>
                  <p className="text-[#E5E5E5]">{b.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
